import React, { useEffect, useState } from "react";
import MaterialTable from "material-table";
import Tooltip from "@material-ui/core/Tooltip";
import { IconButton } from "@material-ui/core";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import { BoxColor, GeneralStyle, useStyles } from "./AdminCategoryList.styled";
import StarRateIcon from "@material-ui/icons/StarRate";
import ModalConfirmAction from "../../ModalConfirmAction/ModalConfirmAction";
import ViewControlMenu from "../../ViewControlMenu/ViewControlMenu";
import TablePagination from "@material-ui/core/TablePagination";
import { AntSwitch } from "../../../helpers/antSwitch";
import moment from "moment";
import { DeleteTwoTone, EditTwoTone } from "@material-ui/icons";

const AdminCategoryList = ({
  categories,
  changeStateCategoryhandler,
  editHandler,
  deleteHandler,
  showCards,
  setShowCards,
}) => {
  const classes = useStyles();
  const [dataPaginated, setDataPaginated] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const [anchorSelected, setAnchorSelected] = useState(null);
  const [openDeleteModal, setOpenDeleteModal] = useState(null);
  const rowsPerPageList = [5, 10, 20];
  const [currentPage, setCurrentPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  useEffect(() => {
    let startIndex = rowsPerPage * currentPage;
    setDataPaginated(categories.slice(startIndex, startIndex + rowsPerPage));
  }, [rowsPerPage, categories, currentPage]);

  const changeState = (rowData) => {
    changeStateCategoryhandler(
      rowData.idCategory,
      rowData.recordState.toUpperCase() === "ACTIVE" ? "INACTIVE" : "ACTIVE"
    );

    rowData.recordState =
      rowData.recordState.toUpperCase() === "ACTIVE" ? "INACTIVE" : "ACTIVE";
  };

  let handleClickActions = (event, rowData) => {
    setAnchorEl(event.currentTarget);
    setAnchorSelected(rowData.idCategory);
  };

  const handleDelete = (data) => {
    setOpenDeleteModal(null);
    deleteHandler(data);
  };

  const showDeleteModal = () => {
    return openDeleteModal ? (
      <ModalConfirmAction
        title={"Are you sure you want to delete this category?"}
        open={openDeleteModal}
        setOpen={setOpenDeleteModal}
        fn={handleDelete}
      />
    ) : null;
  };

  return (
    <GeneralStyle showCards={showCards}>
      {categories && !showCards && (
        <MaterialTable
          title=""
          columns={[
            {
              title: "Category Id",
              field: "idCategory",
              type: "numeric",
              render: (rowData) => {
                return (
                  <>
                    {rowData?.idCategory === 1 && (
                      <StarRateIcon
                        style={{
                          color: "red",
                          fontSize: "17px",
                        }}
                      />
                    )}
                    {rowData?.idCategory}
                  </>
                );
              },
            },
            {
              title: "Category Name",
              field: "categoryName",
              type: "string",
            },
            {
              title: "Assigned Color",
              field: "codeColor",
              align: "center",
              type: "string",
              render: (rowData) => {
                return (
                  <div style={{ display: "flex", justifyContent: "center" }}>
                    <BoxColor colorBackground={rowData?.codeColor}></BoxColor>
                  </div>
                );
              },
            },
            {
              title: "Creation Date",
              field: "createDate",
              type: "datetime",
              render: (rowData) =>
                moment(rowData.createDate).format("YYYY-MM-DD"),
            },
            { title: "Created by", field: "createUser", type: "string" },
            {
              title: "Disable",
              field: "recordState",
              type: "string",
              cellStyle: {
                padding: "0px 16px",
              },
              render: (rowData) => {
                return (
                  <FormControlLabel
                    control={
                      <AntSwitch
                        size="small"
                        disabled={rowData?.idCategory === 1 ? true : false}
                        checked={
                          rowData?.recordState.toUpperCase() === "ACTIVE"
                            ? true
                            : false
                        }
                        onChange={() => changeState(rowData)}
                      />
                    }
                  />
                );
              },
            },
            {
              title: "Actions",
              field: "internal_action",
              cellStyle: {
                padding: "0px 16px",
              },
              render: (rowData) =>
                rowData && (
                  <div style={{ display: "flex", paddingLeft: "15px" }}>
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <Tooltip title="Edit">
                        <IconButton
                          className={classes.active}
                          onClick={() => {
                            setAnchorEl(null);
                            setAnchorSelected(null);
                            editHandler({ ...rowData });
                          }}
                        >
                          <EditTwoTone />
                        </IconButton>
                      </Tooltip>
                    </div>
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <Tooltip title="Delete">
                        <IconButton
                          className={classes.active}
                          disabled={
                            rowData?.recordState?.toLowerCase() === "active"
                          }
                          onClick={() => {
                            setAnchorEl(null);
                            setAnchorSelected(null);
                            setOpenDeleteModal(rowData);
                          }}
                        >
                          <DeleteTwoTone />
                        </IconButton>
                      </Tooltip>
                    </div>
                  </div>
                ),
            },
          ]}
          data={categories}
          options={{
            maxBodyHeight: 450,
            headerStyle: {
              zIndex: 1,
              fontWeight: "bold",
            },
            cellStyle: {
              padding: "5px 10px",
            },
            search: false,
          }}
        />
      )}
      {showCards && (
        <>
          <ViewControlMenu
            title={""}
            identity={"event-categories"}
            showCards={showCards}
            setShowCards={setShowCards}
            list={dataPaginated}
            toggleChecked={changeState}
            handleClickActions={handleClickActions}
            anchorSelected={anchorSelected}
            anchorEl={anchorEl}
            setAnchorEl={setAnchorEl}
            setAnchorSelected={setAnchorSelected}
            setOpenDeleteModal={setOpenDeleteModal}
            setupdateData={editHandler}
            triggerValue={""}
            isAgent={false}
          />
          {categories.length > 0 ? (
            <TablePagination
              component="div"
              style={{ display: "flex", justifyContent: "flex-end" }}
              count={categories.length}
              page={currentPage}
              onPageChange={(e, newPage) => {
                setCurrentPage(newPage);
              }}
              rowsPerPage={rowsPerPage}
              rowsPerPageOptions={rowsPerPageList}
              onRowsPerPageChange={(event) => {
                setRowsPerPage(
                  parseInt(event?.target?.value ? event?.target?.value : "5")
                );
                setCurrentPage(0);
              }}
            />
          ) : (
            <></>
          )}
        </>
      )}
      <p style={{ marginTop: "8px" }}>
        <StarRateIcon
          style={{ color: "red", fontSize: "17px", marginRight: "1em" }}
        />
        1 on 1 category cannot be disabled nor the name be changed
      </p>
      {showDeleteModal()}
    </GeneralStyle>
  );
};

export default AdminCategoryList;
